import { renderToStaticMarkup } from 'react-dom/server';
import { createElement } from 'react';

/**
 * Renders a React component to an HTML string for use in Shaka UI buttons
 */
export const renderIcon = (Component: React.ComponentType<any>, props: any = {}) => {
  return renderToStaticMarkup(createElement(Component, props));
}; 